import React from "react";
import { useDocumentTitle } from "$utils/document-title.js";
import { initiateModal } from "$stores/modal";
import { getTerm } from "$stores/dictionary";
import InitiativeList from "./list";
import InitiativeWizard from "./wizard";

const InitiativesIndex = () => {
    useDocumentTitle(getTerm("initiatives"));

    const openWizard = () => initiateModal(InitiativeWizard, {}, { analyticsLabel: "New Initiative" });

    return (
        <div id="initiatives" className="page-container">
            <div className="main -spacer">
                <main>
                    <div className="main-wrapper">
                        <div className="flex-header">
                            <h1><em>{getTerm("initiatives")}</em></h1>
                            <button className="button -primary -small" onClick={openWizard}>
                                + New {getTerm("initiative")}
                            </button>
                        </div>
                        <InitiativeList onCreateNew={openWizard} />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default InitiativesIndex;
